// extracted by mini-css-extract-plugin
export default {"text":"gO0FMx8tDe2MMwlY31_7"};